function smartRollover() {
	if(document.getElementsByTagName) {
		var images = document.getElementsByTagName("img");

		for(var i=0; i < images.length; i++) {
			if(images[i].getAttribute("src").match("_off."))
			{
				images[i].onmouseover = function() {
					this.setAttribute("src", this.getAttribute("src").replace("_off.", "_on."));
				}
				images[i].onmouseout = function() {
					this.setAttribute("src", this.getAttribute("src").replace("_on.", "_off."));
				}
			}
		}
	}
}

if(window.addEventListener) {
	window.addEventListener("load", smartRollover, false);
}
else if(window.attachEvent) {
	window.attachEvent("onload", smartRollover);
}

/*----mouseover----*/
function swImg(ImgName,str){
	if(document.images){document.images[ImgName].src=str;}
}

jQuery(function($) {
  var topBtn = $('#page-top');  
  topBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  //スクロールしてトップ
    topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
    });
});
jQuery(function($) {
  $('img.roll_fout, .roll_fout img').opOver();
});

jQuery(function () {
    objectFitImages('.woocommerce-product-gallery__image img');
    objectFitImages('.flex-control-thumbs li img');
});

jQuery(document).ready(function() {
    $('.select-select').niceSelect();
});
